import RevokeGreenroomInvitation from '@/connection/greenroom/revoke-greenroom-invitation';
import { serializeError } from '@/store/utils/serialize-error';
import toastTrigger from '@ui/toast/toast-trigger';
import { ProjectStateReducerCreator } from '../types';
import { EToastTypes } from '@ui/toast/toast.types';

const revokeGreenroomInvitationReducer = (create: ProjectStateReducerCreator) => {
  return create.asyncThunk(
    async (
      payload: {
        sessionUuid: string;
        meeting: number;
        email: string;
        channel: number;
      },
      { rejectWithValue }
    ) => {
      try {
        await RevokeGreenroomInvitation(payload);
        return payload;
      } catch (error) {
        console.error(error);
        return rejectWithValue(serializeError(error));
      }
    },
    {
      fulfilled: (state, action) => {
        const sessionUuid = action.payload.sessionUuid;
        const email = action.payload.email;
        if (state.greenroomSessionMeetings?.[sessionUuid].invites) {
          state.greenroomSessionMeetings[sessionUuid].invites = state.greenroomSessionMeetings[
            sessionUuid
          ].invites.filter((invitee) => {
            return invitee.profile?.email !== email;
          });
        }
      },
      rejected: (state, action) => {
        const email = action.meta?.arg?.email;
        toastTrigger(`There was an error revoking presenter status for ${email}`, {
          type: EToastTypes.error,
          autoClose: false,
          description:
            'Please refresh and try again. If the error persists, please directly remove from within Greenroom®.',
        });
      },
    }
  );
};

export default revokeGreenroomInvitationReducer;
